export enum RegepProcessActionTypes {
  External = 1,
  Internal = 2,
}
